import { splitDate } from '@/util/dates'
import { BANK_ACCOUNT, MOBILE_MONEY_ACCOUNT, VOUCHER } from '../constants'

const recruitmentChannelMap = (channel) => {
  return {
    id: channel.id,
    name: channel.channel
  }
}

const nameMap = (obj) => {
  return {
    name: obj.name
  }
}

const nameIdMap = (obj) => {
  return {
    id: obj.id,
    name: obj.name
  }
}

const bankMap = (bank) => {
  return {
    id: bank.id,
    name: bank.name
  }
}

const locationMap = (state) => {
  return {
    id: state.id,
    name: state.name
  }
}

const consultantMap = (consultant) => {
  return {
    id: consultant.id,
    external_id: consultant.external_id,
    jumiaId: consultant.jumia_id,
    isInactive: consultant.status.label.toLowerCase() === 'banned',
    status: consultant.status,
    agreementDate: consultant.date_agreement,
    kraPin: consultant.kra_pin,
    account_type: consultant.account_type || 'consultant',
    geo_location: consultant.geo_location,
    email: consultant.email,
    firstName: consultant.first_name,
    lastName: consultant.last_name,
    birthday: consultant.birthday,
    phoneNumber: consultant.phone_number,
    gender: consultant.gender,
    stateId: consultant.location.parent.id
      ? consultant.location.parent.id
      : null,
    stateName: consultant.location.parent.name
      ? consultant.location.parent.name
      : null,
    timeslotName: consultant.timeslot.name ? consultant.timeslot.name : null,
    timeslotId: consultant.timeslot.id ? consultant.timeslot.id : null,
    jforceTypeName: consultant.jforce_type.name
      ? consultant.jforce_type.name
      : null,
    jforceTypeId: consultant.jforce_type.id ? consultant.jforce_type.id : null,
    languages: consultant.languages,
    networks: consultant.networks,
    trained: consultant.trained,
    sales_experience: consultant.sales_experience,
    own_store: consultant.own_store,
    locationId: consultant.location.parent.id ? consultant.location.id : null,
    recruitmentChannelId: consultant.recruitment_channel.id,
    locationName: consultant.location.name,
    recruitmentChannel: consultant.recruitment_channel.channel,
    levelId: consultant.level.id ? consultant.level.id : null,
    jforce_agreement: consultant.jforce_agreement,
    acceptedTermsAndCondition: consultant.jforce_agreement,
    store_name: consultant.store_name,
    store_photo: consultant.store_photo,
    is_relative_in_jumia: consultant.is_relative_in_jumia,
    tax_id_number: consultant.tax_id_number,
    id_card_number: consultant.id_card_number,
    id_card_picture: consultant.id_card_picture,
    profile_picture: consultant.profile_picture,
    store_type: consultant.store_type,
    address: consultant.address,
    is_convicted: consultant.is_convicted,
    updated_jforce_agreement: consultant.updated_jforce_agreement,
    subject_id: consultant.subject_id,
    signature: consultant.signature,
    preferred_language: consultant.preferred_language,
  }
}

const bankAccountMap = (paymentMethod) => {
  return {
    type:
      paymentMethodsConstantsMap[paymentMethod.payment_method_type].clientType,
    wtiKey:
      paymentMethodsConstantsMap[paymentMethod.payment_method_type].wtiKey,
    formComponentName:
      paymentMethodsConstantsMap[paymentMethod.payment_method_type]
        .formComponentName,
    id: paymentMethod.id,
    accountName: paymentMethod.account_name,
    accountNumber: paymentMethod.account_number,
    updatedAt: splitDate(paymentMethod.updated_at),
    bankId: paymentMethod.bank.id,
    bankName: paymentMethod.bank.bank
  }
}

const mobileMoneyMap = (paymentMethod) => {
  return {
    type:
      paymentMethodsConstantsMap[paymentMethod.payment_method_type].clientType,
    wtiKey:
      paymentMethodsConstantsMap[paymentMethod.payment_method_type].wtiKey,
    formComponentName:
      paymentMethodsConstantsMap[paymentMethod.payment_method_type]
        .formComponentName,
    id: paymentMethod.id,
    accountName: paymentMethod.full_name,
    accountNumber: paymentMethod.phone_number,
    updatedAt: splitDate(paymentMethod.updated_at),
    bankName: 'Mobile-Money'
  }
}

const paymentMethodsConstantsMap = {
  'bank_transfer': {
    wtiKey: 'bank_account',
    clientType: BANK_ACCOUNT,
    routeNameToAdd: 'bank-account-add',
    formComponentName: 'bank-account-form',
    map: bankAccountMap
  },
  'mobile_money': {
    wtiKey: 'mobile_money_account',
    clientType: MOBILE_MONEY_ACCOUNT,
    routeNameToAdd: 'mobile-money-account-add',
    formComponentName: 'mobile-money-form',
    map: mobileMoneyMap
  },
  'voucher': {
    wtiKey: 'voucher',
    clientType: VOUCHER,
    routeNameToAdd: '',
    formComponentName: '',
    map: () => {}
  }
  // 'mtn': {
  //   wtiKey: 'mtn_account',
  //   clientType: MTN_ACCOUNT,
  //   routeNameToAdd: 'mtn-account-add',
  //   formComponentName: 'mobile-money-form',
  //   map: mpesaMap
  // }
}

const paymentMethodMap = (paymentMethod) => {
  return paymentMethodsConstantsMap[paymentMethod.payment_method_type].map(
    paymentMethod
  )
}

const availablePaymentMethodMap = (paymentApiType) => {
  return paymentMethodsConstantsMap[paymentApiType]
}

const paymentMethodClientTypeMap = (paymentApiType) => {
  return paymentMethodsConstantsMap[paymentApiType]
    ? paymentMethodsConstantsMap[paymentApiType].clientType
    : null
}

const toggleFeaturesMap = (toggleFeaturesApi) => {
  return {
    personalInfo: toggleFeaturesApi.personal_info,
    paymentMethods: toggleFeaturesApi.payment_methods,
    sales: toggleFeaturesApi.sales,
    orders: toggleFeaturesApi.orders,
    levels: toggleFeaturesApi.levels,
    teamLeader: toggleFeaturesApi.team_leader,
    teamMembers: toggleFeaturesApi.team_members,
    commissions: toggleFeaturesApi.commissions,
    commissionsOrders: toggleFeaturesApi.commissions_orders,
    success_rate: toggleFeaturesApi.success_rate,
    notifications: toggleFeaturesApi.notifications,
    bonus: toggleFeaturesApi.bonus,
    affiliateLink: toggleFeaturesApi.affiliate_link,
    affiliate: toggleFeaturesApi.affiliate
  }
}

export {
  recruitmentChannelMap,
  bankMap,
  locationMap,
  paymentMethodMap,
  consultantMap,
  paymentMethodClientTypeMap,
  availablePaymentMethodMap,
  toggleFeaturesMap,
  nameIdMap,
  nameMap
}
